//import "channels"
import "tailwindcss/tailwind.css";

import Rails from "@rails/ujs";

Rails.start();
